export default __webpack_public_path__ + "static/media/logo_react.6ce24c58.svg";